/**
 * Serbian overrides for the profile screens.
 *
 * Bosnian moved from ijekavica to ekavica — *uspjela* to *uspela*, *mjesec*
 * to *mesec*, *prijedlog* to *predlog*. Where the two standards agree there
 * is no entry, which is why this file is short and should stay that way.
 *
 * Latin script, matching the rest of the application.
 *
 * Beyond the jat reflex only three words move here: *vrijedi* becomes *važi*
 * rather than *vredi*, matching the sign-in screens; *korišten* becomes
 * *korišćen*; and *ovdje* becomes *ovde*. Everything else on these screens —
 * *nalog*, *tačno*, *spisak*, *saopštio*, *aktivacioni*, *šestocifreni* — is
 * already the Serbian word and needs no line.
 */

import type { ProfileSlice } from '../bs/profile'

export const profile: Partial<ProfileSlice> = {
  'profile.identity.lastLogin': 'Poslednja prijava',
  'profile.identity.note':
    'Ove podatke menja administrator. Ako nešto nije tačno, javite rukovodiocu.',

  'profile.contact.email.hint':
    'Nije obavezna. Većina radnika je nema — obaveštenja u aplikaciji stižu uvek.',
  'profile.contact.sendFailed': 'Slanje nije uspelo.',
  'profile.contact.notify': 'Šalji obaveštenja i na e-poštu',
  'profile.contact.notify.hint': 'Važi samo za potvrđenu adresu.',

  'profile.badge.intro':
    'Umesto kucanja šifre i lozinke, skenirajte svoju karticu telefonom i prijava je gotova. Korisno kad stojite pored mašine, sa rukavicama.',
  'profile.badge.issueFailed': 'Izdavanje nije uspelo.',
  'profile.badge.revokeFailed': 'Poništavanje nije uspelo.',
  'profile.badge.printHint':
    'Odštampajte je sada i plastificirajte. Kod se prikazuje samo ovaj put — ako zatvorite stranicu pre štampe, izdajte novu karticu.',

  'profile.password.title': 'Promena lozinke',
  'profile.password.otherSessionsNote':
    'Nakon promene, sve druge prijave na vaš nalog biće prekinute — ova ostaje aktivna.',
  'profile.password.submit': 'Promeni lozinku',

  'profile.twoFactor.beginFailed': 'Pokretanje nije uspelo.',

  'profile.recovery.intro':
    'Sačuvajte ove kodove na sigurno mesto — svaki važi jednom i služi da uđete u nalog ako izgubite telefon.',

  'profile.sessions.note':
    'Možete biti prijavljeni na više uređaja istovremeno. Ako ste izgubili telefon ili ste ostali prijavljeni na zajedničkom računaru, odjavite taj uređaj ovde.',
  'profile.sessions.lastActivity': 'Poslednja aktivnost {when}',
  'profile.sessions.neverUsed': 'Još nije korišćen',
  'profile.sessions.logoutFailed': 'Odjava nije uspela.',

  'profile.forgot.sendFailed': 'Slanje nije uspelo. Proverite vezu i pokušajte ponovo.',
  'profile.forgot.sent.title': 'Proverite e-poštu',
  'profile.forgot.sent.expiry': 'Link važi sat vremena i može se iskoristiti samo jednom.',

  'profile.reset.allSessionsNote': 'Nakon promene sve prijave na svim uređajima se prekidaju.',
  'profile.reset.success': 'Lozinka je promenjena. Prijavite se novom lozinkom.',
  'profile.reset.failed': 'Promena lozinke nije uspela. Proverite vezu i pokušajte ponovo.',

  'profile.setPassword.failed': 'Postavljanje lozinke nije uspelo.',

  'profile.badgeLogin.failed': 'Prijava karticom nije uspela.',
}
